export default {"src":"/_next/static/media/ethos-logo-forest-for-agents.1beb369f.svg","height":18,"width":166,"blurWidth":0,"blurHeight":0};